export default __webpack_public_path__ + "static/media/GSTR.cb99ea87.jpg";